import { Button } from "react-bootstrap";
import { Tab ,Tabs} from "react-bootstrap";
import { useSelector } from "react-redux";
import "./CreateGroupModal.css";

const EdgeInfoTab = ({
  data ,show, handleClose,handleDeleteEdge
}) => {

  const currentRole = useSelector((state) => state.auth.currentRole);

    const renderTabs = () => {
        const tabs = [
          <Tab
            eventKey="info"
            title={
              <span
                className={"active-tab"}
              >
                Relations
              </span>
            }
            key="info"
          />,
        ];  
        return tabs;
      };
  return (
    <div className={`side-panel ${show ? "open" : ""}`}>
      <div className="tab-header">
        <div className="tabs-container">
        <Tabs>
            {renderTabs()}
          </Tabs>
          <button className="closee-btn " onClick={handleClose}>
            &times;
          </button>
        </div>
      </div>
      <div className="side-panel-body">
      <ul>
              {data && <li className="lighter-bullet">
                {data?.class} {": from"} {data?.sourceNode?.props?.name}{" to "}
                {data?.targetNode?.props.name}
              </li>}
        </ul>
      </div>
      <div className="side-panel-footer">
        {currentRole !== "viewer" && <Button
         className=" del-rem "
          onClick={()=> handleDeleteEdge(data.id)}
        >
          Delete
        </Button>}
        <Button
          variant="secondary"
          className="cance-button"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default EdgeInfoTab;
